export default "__VITE_ASSET__fb6e9a55__"